import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import { useAuth } from '../contexts/AuthContext';

const ProfilePage = () => {
  const { user } = useAuth();
  
  if (!user) {
    return (
      <Box p={3}>
        <Typography>Loading profile...</Typography>
      </Box>
    );
  }

  const { attributes } = user;



  return (
    <Box p={3}>
      <Paper elevation={2} sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Avatar 
            sx={{ 
              width: 100, 
              height: 100, 
              bgcolor: 'primary.main',
              fontSize: '2.5rem',
              mb: 2
            }}
          >
            {attributes?.given_name ? attributes.given_name[0] : 'U'}
          </Avatar>
          <Typography variant="h5" fontWeight="bold">
            {attributes?.name || 'User'}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <List>
          <ListItem>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Full Name" 
              secondary={attributes?.name || 'Not provided'} 
            />
          </ListItem>
          
          <ListItem>
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Email" 
              secondary={attributes?.email || 'Not provided'} 
            />
          </ListItem>
        </List>


      </Paper>
    </Box>
  );
};

export default ProfilePage;